import { createReducer, on } from '@ngrx/store';
import { VeridionExportState, initialVeridionExportState } from './veridion-export.state';
import * as VeridionExportActions from './veridion-export.actions';

export const veridionExportReducer = createReducer(
  initialVeridionExportState,

  // ============================================
  // Validate Export Credits
  // ============================================
  on(VeridionExportActions.validateExportCredits, (state): VeridionExportState => ({
    ...state,
    validation: {
      isLoading: true,
      result: null,
      error: null
    }
  })),

  on(VeridionExportActions.validateExportCreditsSuccess, (state, { validation }): VeridionExportState => ({
    ...state,
    validation: {
      isLoading: false,
      result: validation,
      error: null
    }
  })),

  on(VeridionExportActions.validateExportCreditsFailure, (state, { error }): VeridionExportState => ({
    ...state,
    validation: {
      isLoading: false,
      result: null,
      error: error?.message || error?.error?.message || 'Failed to validate export credits'
    }
  })),

  // ============================================
  // Start Export
  // ============================================
  on(VeridionExportActions.startVeridionExport, (state): VeridionExportState => ({
    ...state,
    startExport: {
      isLoading: true,
      result: null,
      error: null
    }
  })),

  on(VeridionExportActions.startVeridionExportSuccess, (state, { result }): VeridionExportState => ({
    ...state,
    startExport: {
      isLoading: false,
      result,
      error: null
    }
  })),

  on(VeridionExportActions.startVeridionExportFailure, (state, { error }): VeridionExportState => ({
    ...state,
    startExport: {
      isLoading: false,
      result: null,
      error: error?.message || error?.error?.message || 'Failed to start export'
    }
  })),

  // ============================================
  // Load Exports
  // ============================================
  on(VeridionExportActions.loadExports, (state): VeridionExportState => ({
    ...state,
    exports: {
      ...state.exports,
      isLoading: true,
      error: null
    }
  })),

  on(VeridionExportActions.loadExportsSuccess, (state, { exports, pagination }): VeridionExportState => ({
    ...state,
    exports: {
      items: exports,
      isLoading: false,
      error: null,
      pagination
    }
  })),

  on(VeridionExportActions.loadExportsFailure, (state, { error }): VeridionExportState => ({
    ...state,
    exports: {
      ...state.exports,
      isLoading: false,
      error: error?.message || error?.error?.message || 'Failed to load exports'
    }
  })),

  // ============================================
  // Download Export
  // ============================================
  on(VeridionExportActions.downloadExport, (state, { exportId }): VeridionExportState => ({
    ...state,
    download: {
      downloadingIds: [...state.download.downloadingIds, exportId],
      error: null
    }
  })),

  on(VeridionExportActions.downloadExportSuccess, (state, { exportId }): VeridionExportState => ({
    ...state,
    download: {
      downloadingIds: state.download.downloadingIds.filter(id => id !== exportId),
      error: null
    }
  })),

  on(VeridionExportActions.downloadExportFailure, (state, { exportId, error }): VeridionExportState => ({
    ...state,
    download: {
      downloadingIds: state.download.downloadingIds.filter(id => id !== exportId),
      error: error?.message || error?.error?.message || 'Failed to download export'
    }
  })),

  // ============================================
  // Reset
  // ============================================
  on(VeridionExportActions.resetExportState, (): VeridionExportState => ({
    ...initialVeridionExportState
  })),

  on(VeridionExportActions.resetValidationState, (state): VeridionExportState => ({
    ...state,
    validation: {
      isLoading: false,
      result: null,
      error: null
    }
  })),

  on(VeridionExportActions.resetStartExportState, (state): VeridionExportState => ({
    ...state,
    startExport: {
      isLoading: false,
      result: null,
      error: null
    }
  }))
);

export type { VeridionExportState };
